import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {

  initValue:any;

  @Input('pickerType') pickerType;
  @Input('searchLabel') searchLabel;
  @Input('searchPlaceholder') searchPlaceholder;
  @Input('initData') searchData;

  @Output() searchValue: EventEmitter<number> =   new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  applyFilter(filterValue:any) {
    this.searchValue.emit(filterValue);
  }
}
